<button type="button" class="backdrop" [attr.aria-label]="'common.close' | translate" (click)="close()"></button>

<div #dialog class="dialog" tabindex="-1" role="dialog" aria-modal="true" clTrapFocus>
    <router-outlet />
</div>
